export default function getCategoryId(arr) {
  return arr && arr[0].categoryId ? arr[0].categoryId : 0;
}
